import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable()
export class ChangePasswordService {

  api: string = environment.backend;

  constructor(private http: HttpClient) { }

  login(user) {
    return this.http.put(this.api + 'login/', user);
  }
}
